import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import { createSiteShell } from "@coremind/foundation-shell-core";
import "@coremind/identity-core";
import { wwwAdapter } from "./adapter";
const env = window.__COREMIND_ENV__ ?? {};
const basename = window.location.pathname.startsWith("/www") ? "/www" : undefined;
// Public landing page — no hard auth gate; auth-awareness is handled inside components.
const siteHostname = window.location.hostname.startsWith("ui.")
    ? `www.${window.location.hostname.slice(3)}`
    : env.VITE_SITE_HOSTNAME;
const App = createSiteShell(wwwAdapter, {
    basename,
    siteHostname,
    auth: {
        userPoolId: env.VITE_COGNITO_USER_POOL_ID ?? "",
        userPoolClientId: env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? "",
        identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID,
        oauth: env.VITE_COGNITO_OAUTH_DOMAIN
            ? {
                domain: env.VITE_COGNITO_OAUTH_DOMAIN,
                redirectSignIn: [env.VITE_COGNITO_OAUTH_REDIRECT_SIGNIN].filter(Boolean),
                redirectSignOut: [env.VITE_COGNITO_OAUTH_REDIRECT_SIGNOUT].filter(Boolean),
                scopes: (env.VITE_COGNITO_OAUTH_SCOPES ?? "email openid profile").split(" "),
                responseType: (env.VITE_COGNITO_OAUTH_RESPONSE_TYPE ?? "code"),
            }
            : undefined,
    },
    apiBaseUrl: env.VITE_API_BASE_URL,
});
createRoot(document.getElementById("root")).render(_jsx(App, {}));
